import { render, staticRenderFns } from "./DetailPageLibrary.vue?vue&type=template&id=532db3f0&scoped=true"
import script from "./DetailPageLibrary.vue?vue&type=script&lang=js"
export * from "./DetailPageLibrary.vue?vue&type=script&lang=js"
import style0 from "./DetailPageLibrary.vue?vue&type=style&index=0&id=532db3f0&prod&lang=scss&scoped=true"
import style1 from "./DetailPageLibrary.vue?vue&type=style&index=1&id=532db3f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532db3f0",
  null
  
)

export default component.exports